import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { sendGAEvent } from '@next/third-parties/google'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const validateUrl = (url: string) => {
  // Update the regex to remove unnecessary escape characters
  const regex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(:\d+)?(\/.*)?$/i;
  return regex.test(url);
};

// Function to extract company name from email domain
export const getCompanyNameFromDomain = (domain: string): string => {
  if (!domain) return '';
  
  // Extract the first part of the domain (before the TLD)
  const companyPart = domain.split('.')[0];
  
  // Capitalize first letter of each word
  return companyPart
    .split(/[\s-_]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const sendGACustomEvent = (itemName: string) => {
  sendGAEvent(
    'event',
    'buttonClicked',
    {
      value: itemName,
    }
  );
};